'use strict';

var _bindings;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // you can give this component the startdate in url. [siteurl]/#!/[date in unix-timestamp]

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresDeparturesCalendar = function () {
    function WinresDeparturesCalendar($scope, $filter, $sce, localizationService, internetClassificationService, $location, $window, $rootScope) {
        _classCallCheck(this, WinresDeparturesCalendar);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.$sce = $sce;
        this.localizationService = localizationService;
        this.internetClassificationService = internetClassificationService;
        this.$location = $location;
        this.availableMonths = {};
        this.selectedMonths = {};
        this.firstMonth = {};
        this.lastMonth = {};
        this.$window = $window;
        this.cachedMonths = [];
    }

    _createClass(WinresDeparturesCalendar, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.showType = !this.destinationCodes && this.allowChangePrimaryInternetClassifications !== 'false';

            this.intClassesLoaded = false;

            this.type1 = null;

            this.$scope.$watch("$ctrl.firstMonth", function () {
                _this.monthsChanged();
            });

            this.$scope.$watch("$ctrl.lastMonth", function () {
                _this.monthsChanged();
            });

            // Length slider set up
            this.$scope.length_slider = {
                min: 1,
                max: 30,
                options: {
                    floor: 1,
                    ceil: 30,
                    onEnd: function onEnd() {
                        _this.autoUpdate();
                    },
                    translate: function translate(num) {
                        return num + ' ' + _this.$filter('i18next')('winres_departures.days_short');
                    }
                }
            };
            if (this.sliderMaxLength) {
                this.$scope.length_slider.max = this.sliderMaxLength;
                this.$scope.length_slider.options.ceil = this.sliderMaxLength;
            }
            if (this.sliderMinLength) {
                this.$scope.length_slider.min = this.sliderMinLength;
                this.$scope.length_slider.options.floor = this.sliderMinLength;
            }
            if (this.allowChangeLength == 'false') {
                this.$scope.length_slider.options.disabled = true;
            }

            this.loadInternetClassifications();
            this.initMonths();
        }
    }, {
        key: 'loadInternetClassifications',
        value: function loadInternetClassifications() {
            var _this2 = this;

            this.internetClassificationService.loadInternetClassifications().then(function (types) {

                //console.log("types", types);

                // removes the unwanted classifications
                _this2.types = [];
                _.each(types, function (type) {
                    if (_this2.removeInt1Classes == null || _this2.removeInt1Classes != null && !_this2.removeInt1Classes.includes(type.Code)) {
                        _this2.types.push(type);
                    }
                });
                //console.log("types", this.types);

                // rest of this function is the default internet classifications (if set)
                // currently only sets int-clas1 since others are not used afaik

                if (_this2.type1Choice) {
                    //console.log('Initializing type1Choice', this.defaultInternetClassifications1);
                    _this2.deselectAllTypes();
                    _this2.type1 = _this2.defaultInternetClassifications1;
                }

                if (_this2.defaultInternetClassifications1 != null) {
                    _this2.onType1Change();
                }

                _this2.initMonths();
                _this2.monthsChanged();
                _this2.intClassesLoaded = true;

                _this2.getAvailabelMonths();
            });
        }
    }, {
        key: 'initMonths',
        value: function initMonths() {
            var currentDate = new Date();

            // start from 1 since the position 0 is meant for the "choose month"-string
            for (var i = 1; i < this.totalAvailableMonths; i++) {
                var newDate = new Date();
                if (newDate.getDate() > 28) {
                    newDate.setDate(28);
                }

                // get first and last day of the month
                if (i == 1) {
                    newDate.setMonth(currentDate.getMonth());
                    var y = newDate.getFullYear(),
                        m = newDate.getMonth();
                    var firstDay = this.$filter("date")(currentDate, 'yyyy-MM-dd');
                } else {
                    newDate.setMonth(currentDate.getMonth() + i - 1);
                    var y = newDate.getFullYear(),
                        m = newDate.getMonth();
                    var firstDay = this.$filter("date")(new Date(y, m, 1), 'yyyy-MM-dd');
                }
                var lastDay = this.$filter("date")(new Date(y, m + 1, 0), 'yyyy-MM-dd');
                var fullMonth = {
                    "year": this.$filter("date")(newDate, 'yyyy'),
                    "number": this.$filter("date")(newDate, 'M'),
                    "name": this.getIfNeedsName(i) ? "months." + this.$filter("date")(newDate, 'MMMM') : this.availableMonths[i].name,
                    "firstDay": firstDay, "lastDay": lastDay, "id": i,
                    "searchCriteria": {
                        "StartDate": firstDay,
                        "EndDate": lastDay,
                        "LengthInDaysMinimum": this.$scope.length_slider.min ? this.$scope.length_slider.min : null,
                        "LengthInDaysMaximum": this.$scope.length_slider.max ? this.$scope.length_slider.max : null,
                        "Classifications1": this.getType1(),
                        "IgnoreCapacity": this.showFullDepartures ? this.showFullDepartures : null,
                        "Limit": this.limit || 10,
                        "Flags": ["MatchStartDate"]
                    }
                };
                this.availableMonths[i] = fullMonth;
            }
        }
    }, {
        key: 'getIfNeedsName',
        value: function getIfNeedsName(i) {
            if (this.availableMonths[i] == null) {
                return true;
            }
            return false;
        }
    }, {
        key: 'getType1',
        value: function getType1() {
            if (this.type1 == null || this.type1 == "") {
                var types = [];

                _.each(this.types, function (type) {
                    types.push(type.Code);
                });

                return types;
            }
            return [this.type1];
        }
    }, {
        key: 'getAvailabelMonths',
        value: function getAvailabelMonths() {
            var _this3 = this;

            // localization is here because i18next filter does not exist when initMonths() is run.
            //var test = this.$filter('i18next')("months.January");
            //if(test != "" && this.availableMonths[1].name.includes("months") ){ //this breaks IE11 month names.
            if (this.availableMonths) {
                var monthLength = 0;
                _.each(this.availableMonths, function (month) {
                    month.name = _this3.$filter('i18next')(month.name) + " " + month.year;
                    monthLength++;
                });

                this.date = this.$filter('date')(this.$location.url().replace("/", "") * 1000, 'yyyy-MM-dd');

                if (this.defaultMonthsDisplayed != null) {
                    var months = this.defaultMonthsDisplayed;
                } else {
                    var months = monthLength; // last month in dropdown list.
                }

                //these set the deafult months

                this.firstMonth = this.availableMonths[1];
                this.lastMonth = this.availableMonths[months];

                // the first object of the this.availableMonths is reserved to "which month would you like to travel string"

                for (var i = 1; i < this.totalAvailableMonths; i++) {
                    if (this.availableMonths[i].firstDay == this.date) {
                        this.firstMonth = this.availableMonths[i];
                        this.lastMonth = this.availableMonths[i + 3];
                    }
                }
                this.monthsChanged();

                if (this.mode === "selector") {
                    var newDate = new Date();
                    this.availableMonths[0] = {
                        "year": this.$filter("date")(newDate, 'yyyy'),
                        "number": this.$filter("date")(newDate, 'M'),
                        "name": this.$filter('i18next')("common.which_month_would_you_like_to_travel"),
                        "id": 0
                    };

                    this.firstMonth = this.availableMonths[0];
                }
                this.cachedMonths = this.availableMonths;
            }
            return this.availableMonths;
        }
    }, {
        key: 'monthsChanged',
        value: function monthsChanged() {
            //if(!this.lastMonth) return;
            var monthsAmount = this.lastMonth.id - this.firstMonth.id;
            this.selectedMonths = {};
            var j = 0;
            for (var i = this.firstMonth.id; i <= this.firstMonth.id + monthsAmount; i++) {
                this.selectedMonths[j] = this.availableMonths[i];
                j++;
            }
        }
    }, {
        key: 'updateType',
        value: function updateType() {
            this.autoUpdate();
        }
    }, {
        key: 'autoUpdate',
        value: function autoUpdate() {
            var _this4 = this;

            _.each(this.availableMonths, function (month) {
                month.searchCriteria.Classifications1 = _this4.type1 != "" ? _this4.type1 : null;
                month.searchCriteria.LengthInDaysMinimum = _this4.$scope.length_slider.min ? _this4.$scope.length_slider.min : null;
                month.searchCriteria.LengthInDaysMaximum = _this4.$scope.length_slider.max ? _this4.$scope.length_slider.max : null;
            });

            this.initMonths();
            this.monthsChanged();
        }
    }, {
        key: 'goToPage',
        value: function goToPage() {
            this.$window.location = this.calendarUrl + "/#!/" + Math.round(new Date(this.firstMonth.firstDay + " 00:00:00").getTime() / 1000);
        }
    }]);

    return WinresDeparturesCalendar;
}();

WinresDeparturesCalendar.$inject = ['$scope', '$filter', '$sce', 'localizationService', 'internetClassificationService', '$location', '$window', '$rootScope'];

function getTemplate($attrs, $sce) {
    if ($attrs.mode === "selector") {
        return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'departures-calendar-selector';
    }
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'departures-calendar';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('departures-calendar', require('./winresDeparturesCalendar.html'));
    $templateCache.put('departures-calendar-selector', require('./winresDeparturesCalendarSelector.html'));
}]);

_module3.default.component('winresDeparturesCalendar', {
    templateUrl: getTemplate,
    controller: WinresDeparturesCalendar,
    bindings: (_bindings = {
        mode: '@', // if selector: uses the selection mode that has ability to go to specific month
        totalAvailableMonths: '@', //required
        showFullDepartures: '@',
        limit: '@',

        // lenght
        allowChangeLength: '@',
        sliderMinLength: '@',
        slideMaxLength: '@'
    }, _defineProperty(_bindings, 'allowChangeLength', '@'), _defineProperty(_bindings, 'isLengthOpen', '@'), _defineProperty(_bindings, 'calendarUrl', '@'), _defineProperty(_bindings, 'removeInt1Classes', '@'), _defineProperty(_bindings, 'defaultMonthsDisplayed', '@'), _bindings),
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDeparturesCalendar/winresDeparturesCalendar.js
// module id = 365
// module chunks = 2